import { useTranslation } from 'react-i18next';

/**
 * Lo stato vuoto — e non e' il caso limite, e' la schermata principale.
 *
 * Le istanze nascono solo per un giocatore con `tagVerified` (Gate F1, `worker.ts:78-90`), che si
 * diventa ricevendo un `player.tag_verified` — evento tuttora PUSHED, e nessuno lo emette in modo
 * contrattato. Il ruolo `quest-player` oggi ce l'hanno due sole utenze di collaudo. ⇒ per la quasi
 * totalita' degli utenti `GET /v1/missions` risponde `200 {"missions":[]}`, e questa resta la
 * faccia normale della sezione.
 *
 * ⚠️ MA NON DIRE «Quest e' inerte, la lista e' vuota per CHIUNQUE» — era vero e non lo e' piu' dal
 * 2026-08-28. Il poller qCrC (`workers/qcrcPoll.ts`) sintetizza `cr.battle` da se', quindi le
 * istanze dei due collaudi avanzano e si completano senza che nessuno pushi nulla: al 29/8 il DB
 * di produzione porta righe `completed`/`claimed`. «Nessun emittente» non e' «nessun dato» quando
 * c'e' un pull — e chi progetta partendo dalla prima frase progetta su una premessa falsa.
 *
 * Percio' e' una schermata scritta, non una lista di zero elementi. E dice il vero senza spiegare
 * all'utente un problema di piattaforma che non lo riguarda: "non ce ne sono adesso, torna piu'
 * tardi" e' esatto sia oggi (nessun emittente) sia domani (giornata senza missioni assegnate).
 */
export function MissionsEmpty() {
  const { t } = useTranslation('missions');
  return (
    <div className="rounded-xl bg-bg-secondary p-6 text-center">
      <p className="text-sm font-bold text-fg">{t('empty.title')}</p>
      <p className="mt-1 text-sm text-fg-muted">{t('empty.text')}</p>
    </div>
  );
}
